type Severity = { border: string; background: string; text: string };

export const SEVERITY: Record<"red" | "amber" | "blue" | "gray", Severity> = {
  red: { border: "#DC2626", background: "#FEE2E2", text: "#991B1B" },
  amber: { border: "#D97706", background: "#FEF3C7", text: "#92400E" },
  blue: { border: "#2563EB", background: "#DBEAFE", text: "#1E40AF" },
  gray: { border: "#6B7280", background: "#F3F4F6", text: "#374151" },
};

export const NOTIFICATION_TYPES = {
  NOTIFICATION: { title: "NOTIFICATION", icon: "🔔", severity: SEVERITY.blue },
  ACCIDENT: { title: "ACCIDENT", icon: "🚧", severity: SEVERITY.red },
  ROBBERY: { title: "ROBBERY", icon: "🚨", severity: SEVERITY.red },
  LAW_INFRACTION: {
    title: "LAW_INFRACTION",
    icon: "⚖️",
    severity: SEVERITY.amber,
  },
  OTHER: { title: "OTHER", icon: "❔", severity: SEVERITY.gray },
};
